
const isIOS = (): boolean => {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
    }

export default isIOS